import { CreateReportItemRequest, CreateReportItemsFromSelectionsRequest, ReorderReportItemsReply, ReorderReportItemsRequest, ReportItemReply, ReportItemsReply, UpdateReportItemRequest } from "@/backend/express/controllers/reportItemController";
import { Client } from "./client";
import { FusaReply } from "@/types/replyTypes";
import { ProcedureReportRequest } from "@/backend/express/controllers/reportController";

export class ReportItemController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  public async readAllReportItems(reportId: string): Promise<ReportItemsReply> {
    return this.client.read(`/api/reportItems/readAllForReport/${reportId}`);
  }

  public async createReportItem(req: CreateReportItemRequest): Promise<ReportItemReply> {
    return this.client.create(`/api/reportItems`, req);
  }

  public async updateReportItem(req: UpdateReportItemRequest): Promise<ReportItemReply> {
    return this.client.update(`/api/reportItems`, req);
  }

  public async deleteReportItem(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/reportItems/${id}`);
  }

  public async readReportItem(id: string): Promise<ReportItemReply> {
    return this.client.read(`/api/reportItems/${id}`);
  }

  public async reorderReportItems(req: ReorderReportItemsRequest): Promise<ReorderReportItemsReply> {
    return this.client.update(`/api/reportItems/reorder`, req);
  }

  public async importForProcedure(req: ProcedureReportRequest): Promise<ReportItemsReply> {
    return this.client.create(`/api/reportItems/importFromProcedure`, req);
  }

  public async createFromSelectedItems(req: CreateReportItemsFromSelectionsRequest): Promise<FusaReply> {
    return this.client.create(`/api/reportItems/createFromSelectedItems`, req);
  }
}
